import React, { createContext, useContext, useState, useEffect } from 'react';
import Cookies from 'js-cookie';
import axios from 'axios';

const AuthContext = createContext(null);
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check for existing session
    const token = Cookies.get('admin_token');
    const storedUser = Cookies.get('admin_user');
    
    if (token && storedUser) {
      try {
        setUser(JSON.parse(storedUser));
      } catch (e) {
        console.error('Failed to parse user data');
      }
    }
    setLoading(false);
  }, []);

  const login = async (email, otp) => {
    try {
      const response = await axios.post(`${API}/auth/verify-otp`, { email, otp });
      console.log('Login response:', response.data);
      const { token, user: userData } = response.data;
      
      // Store token and user data in cookies (7 days expiry)
      Cookies.set('admin_token', token, { expires: 7 });
      Cookies.set('admin_user', JSON.stringify(userData), { expires: 7 });
      
      setUser(userData);
      return { success: true };
    } catch (error) {
      console.error('Login error:', error);
      return { success: false, message: error.response?.data?.detail || error.response?.data?.message || 'Login failed' };
    }
  };

  const logout = () => {
    Cookies.remove('admin_token');
    Cookies.remove('admin_user');
    setUser(null);
  };

  const sendOTP = async (email, password) => {
    try {
      const response = await axios.post(`${API}/auth/send-otp`, { email, password });
      return { success: true, message: response.data.message };
    } catch (error) {
      return { success: false, message: error.response?.data?.message || 'Failed to send OTP' };
    }
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, sendOTP, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};
